import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";
import CommonButton from "../../common/components/CommonButton";

const options = {
    YES: 'Yes',
    NO: "No"
}

const ProjectBackground = ({
    formData,
    handleInputChange,
    errors,
    setFormData
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            padding="0px"
            background="#D0FFD3"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>Project Background & Interests</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add your Project Background & Interests</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={12}>
                        <Typography fontSize={14} fontWeight={600}>Have you worked on any project before?</Typography>
                        <Box display="flex" gap={1} mt={0.8}>
                            <CommonButton
                                label={options.YES}
                                width="80px"
                                fontWeight={600}
                                color={formData.workedBefore === options.YES ? theme.palette.primary.main : theme.palette.background.dark}
                                background={formData.workedBefore === options.YES ? theme.palette.secondary.main : 'white'}
                                handleClick={() =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        workedBefore: options.YES
                                    }))}
                                marginBottom="0px"
                                border={`1px solid #0000001A`}
                                height="35px"
                            />
                            <CommonButton
                                label={options.NO}
                                border={`1px solid #0000001A`}
                                width="70px"
                                fontWeight={600}
                                color={formData.workedBefore === options.NO ? theme.palette.primary.main : theme.palette.background.dark}
                                background={formData.workedBefore === options.NO ? theme.palette.secondary.main : 'white'}
                                handleClick={() =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        workedBefore: options.NO
                                    }))}
                                marginBottom="0px"
                                height="35px"
                            />
                        </Box>
                    </Grid>
                    <Grid item md={12}>
                        <CommonFormField
                            label="Have you worked on any project before?"
                            type="email"
                            name="projectDescription"
                            value={formData.projectDescription}
                            onChange={handleInputChange}
                            placeholder="List here"
                            error={errors.projectDescription}
                            multiline
                        />
                    </Grid>
                    <Grid item md={12}>
                        <CommonFormField
                            label="Area of Interest"
                            type="email"
                            name="areaOfInterest"
                            value={formData.areaOfInterest}
                            onChange={handleInputChange}
                            placeholder="e.g. AI"
                            error={errors.areaOfInterest}
                        />
                    </Grid>
                </Grid>
            }
        />
    )
}

export default ProjectBackground;